import { render } from "./MenuGroup.vue?vue&type=template&id=7cf8bee0"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"

import "./MenuGroup.vue?vue&type=style&index=0&id=7cf8bee0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__